import { render } from "./ModalNotAttend.vue?vue&type=template&id=03d6c932&scoped=true"
import script from "./ModalNotAttend.vue?vue&type=script&lang=js"
export * from "./ModalNotAttend.vue?vue&type=script&lang=js"

import "./ModalNotAttend.vue?vue&type=style&index=0&id=03d6c932&scoped=true&lang=css"

import exportComponent from "/Users/thanyakornphanthamit/Desktop/vue/wedday/guest-registation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03d6c932"]])

export default __exports__